import { Link, useLocation, useNavigate } from "react-router-dom";
import "./App.css";
import { trToEn } from "./utils/urlMap";
import mainLogo from "./assets/teknokent_clip.png";
import mainLogo2 from "./assets/logo_beyaz.jpeg";

import a from "./assets/POLSAN_TEKNOKENT_LOGO_forRaster-02-koyu.png";
import b from "./assets/POLSAN_TEKNOKENT_LOGO_forRaster-02.jpg";
import c from "./assets/WhatsApp Image 2025-12-29 at 16.16.44 (1).jpeg";


import polsanLogo from "./assets/polsan-logo.png";
import polsanLogoBeyaz from "./assets/polsan-logo-beyaz.PNG";

function Header() {
  const location = useLocation();
  const navigate = useNavigate();

  const changeToEN = () => {
    const next = trToEn[location.pathname] || "/en";
    navigate(next);
  };

  return (
      <header class="header">
        <nav class="navbar navbar-expand-lg bg-body-tertiary header-main">
          <div className="container-fluid">
            <Link to="/"><img src={mainLogo} alt="Polsan Logo" class="navbar-brand d-inline-block align-text-top logo-img" /></Link>
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
              <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarNav">
              <ul class="navbar-nav me-auto mb-2 mb-lg-0 ms-lg-5">
                <li class="nav-item dropdown">
                  <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                    Hakkımızda
                  </a>
                  <ul class="dropdown-menu sub-menu">
                    <li><a class="dropdown-item" href="/hakkimizda">POLSAN Teknokent</a></li>
                    <li><a class="dropdown-item" href="/ortaklik-yapisi">Ortaklık Yapısı</a></li>
                    <li><a class="dropdown-item" href="/yonetim-kurulu">Yönetim Kurulu</a></li>
                    <li><a class="dropdown-item" href="/">Şirket Yönetimi</a></li>
                  </ul>
                </li>
                {/* <li class="nav-item nav-link">
                  <Link to="/">Firmalar</Link>
                </li> */}
                <li class="nav-item dropdown">
                  <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                    Kurumsal
                  </a>
                  <ul class="dropdown-menu sub-menu">
                    <li><a class="dropdown-item" href="/tto">TTO</a></li>
                    <li><a class="dropdown-item" href="/girisimcilik">Girişimcilik</a></li>
                    <li><a class="dropdown-item" href="/isbirligi">Üniversite - Sanayi İşbirliği</a></li>
                    <li><a class="dropdown-item" href="/kumelenme">Kümelenmeler</a></li>
                  </ul>
                </li>
                <li class="nav-item nav-link">
                  <Link to="/medya">Medya</Link>
                </li>
                <li class="nav-item nav-link">
                  <Link to="/iletisim">İletişim</Link>
                </li>
              </ul>
              <div class="nav-item nav-link me-2 p-2 basvuru-menu">
                <Link to="/basvuru">Başvuru</Link>
              </div>
              <button onClick={changeToEN} class="btn btn-sm me-2 btn-lng">
                EN / TR 
              </button>
              <div class="d-flex">
                {/* <a href="https://polsan.com.tr" class="me-2 p-2 btn-polsan" target="_blank">POLSAN</a> */}
                {/* <a href="https://polsan.com.tr" class="me-2 p-2 btn-polsan-img" target="_blank"><img src={polsanLogoBeyaz} alt="POLSAN Logo" class="polsan-logo" /></a> */}
                <a href="https://polsan.com.tr" class="p-2 btn-polsan-img" target="_blank"><img src={polsanLogo} alt="POLSAN Logo" class="polsan-logo" /></a>
              </div>
            </div>
          </div>
        </nav>
      </header>
  );
}

export default Header;
